import { useEffect } from 'react'

import { isVisitorOnCallSelector, useStore } from '@liveHelper/models/store'
import { useTrackCallProgress } from '@liveHelper/tracking/useLiveHelperTracking'

/**
 * Hook to track when the visitor is on a call every 10 seconds.
 */
export const useTrackOnCallProgress = () => {
  const isVisitorOnCall = useStore(isVisitorOnCallSelector)
  const trackCallProgress = useTrackCallProgress()

  useEffect(() => {
    let interval: ReturnType<typeof setInterval> | undefined = undefined
    if (isVisitorOnCall) {
      trackCallProgress()
      interval = setInterval(() => {
        trackCallProgress()
      }, 10000)
    } else if (interval) {
      clearInterval(interval)
    }

    return () => {
      if (interval) {
        clearInterval(interval)
      }
    }
  }, [isVisitorOnCall, trackCallProgress])
}
